export default "__VITE_ASSET__BpkFOgXj__"